import { Card, Row, Col, Form, Container, Button } from "react-bootstrap";
import { useCallback, useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ProfileContext } from "pages/Profile";
import { toast } from "react-toastify";

export default function Notifications() {

  const { profile, setProfile } = useContext(ProfileContext)
  const { user: authUser } = useSelector(x => x.auth)

  const url = process.env.REACT_APP_URL;

  const [notifNextMeeting, setNotifNextMeeting] = useState(false);
  const [notifMeetingRoleAssignment, setNotifMeetingRoleAssignment] = useState(false);
  const [notifNewsletter, setNotifNewsletter] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false)
  const [isDisabled, setIsDisabled] = useState(true)

  useEffect(() => {
    setNotifNextMeeting(profile.notifNextMeeting || false);
    setNotifMeetingRoleAssignment(profile.notifMeetingRoleAssignment || false);
    setNotifNewsletter(profile.notifNewsletter || false);
  }, [profile.notifNextMeeting, profile.notifMeetingRoleAssignment, profile.notifNewsletter]);

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    setSaveLoading(true)
    try {
      const data = {
        notifNextMeeting: notifNextMeeting,
        notifMeetingRoleAssignment: notifMeetingRoleAssignment,
        notifNewsletter: notifNewsletter
      };
      const response = await fetch(`${url}/users/${profile._id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authUser.token}`
        },
        body: JSON.stringify(data)
      });
      const result = await response.json();
      setProfile(result)
      toast.success('Notifications updated successfully', { position: 'bottom-left' });
      setSaveLoading(false)
    }
    catch (error) {
      console.error('Error updating notifications:', error);
      toast.error('Failed to update notifications');
      setSaveLoading(false)
    }
  }, [notifNextMeeting, notifMeetingRoleAssignment, notifNewsletter, profile._id, authUser.token, setProfile, url]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key === 's') {
        e.preventDefault();
        handleSubmit(e);
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleSubmit]);

  useEffect(() => {
    (authUser.user.acl === 'Officer' || authUser.user._id === profile._id) &&
      setIsDisabled(false)
  }, [authUser.user.acl, authUser.user._id, profile._id])

  return (
    <Card data-bs-theme={'dark'} className="mt-3 mb-3">
      <Form>
        <Card.Header>
          <Row className="mt-3 mb-3"><Col>Notifications</Col></Row>
        </Card.Header>
        <Card.Body>
          <Container>
            <Row>
              <Col>
                <p>Notify me for the following:</p>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col>
                <Row className="mt-3 mb-3">
                  <Col xs={8} lg={10}>
                    <Form.Check // prettier-ignore
                      disabled={isDisabled}
                      type="switch"
                      label="Next Meeting"
                      checked={notifNextMeeting}
                      onChange={e => setNotifNextMeeting(e.target.checked)}
                    />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col xs={8} lg={10}>
                    <Form.Check // prettier-ignore
                      disabled={isDisabled}
                      type="switch"
                      label="Meeting Role Assignment"
                      checked={notifMeetingRoleAssignment}
                      onChange={e => setNotifMeetingRoleAssignment(e.target.checked)}
                    />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col xs={8} lg={10}>
                    <Form.Check // prettier-ignore
                      disabled={isDisabled}
                      type="switch"
                      label="Newsletter"
                      checked={notifNewsletter}
                      onChange={e => setNotifNewsletter(e.target.checked)}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </Card.Body>
        {
          (authUser.user.acl === 'Officer' || authUser.user._id === profile._id) &&
          <Card.Footer>
            <Row className="mt-3 mb-3">
              {saveLoading
                ?
                'Saving profile ... '
                :
                <Col className="text-end">
                  <Button variant="primary" onClick={handleSubmit}>Save Changes</Button><br />
                </Col>
              }
            </Row>
          </Card.Footer>
        }
      </Form>
    </Card >
  )
}